import React, { useCallback, memo } from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SwitchListItem from '../../../../../../list-items/SwitchListItem/SwitchListItem';
import { HOLLOW_CENTER_WAVE_STYLES, HOLLOW_CENTER_TOOLTIP } from '../../../../Preview/PreviewDisplayConstants';

const WaveLayerHollowCenterListItem = memo(({ index, waveStyle, hollowCenter, updateWaveLayerCustomOptions }) => {
    const handleChange = useCallback(
        (_, value) => updateWaveLayerCustomOptions(index, "hollowCenter", value),
        [index]
    );

    // Only the styles that fill the center have something to hollow out.
    if (!HOLLOW_CENTER_WAVE_STYLES.includes(waveStyle))
        return null;

    return (
        <SwitchListItem
            checked={hollowCenter !== undefined ? hollowCenter : false}
            onChange={handleChange}
            text="Hollow Center"
            toolTip={HOLLOW_CENTER_TOOLTIP}
        />
    );
});

const mapStateToProps = (state, { index }) => {
    const { waveStyle, hollowCenter } = state.createPreview.present.videoSettings.visualizer.waveCircles[index].customOptions;
    return { waveStyle, hollowCenter };
}

const mapDispatchToProps = (dispatch) => ({
    updateWaveLayerCustomOptions: (index, key, value) => dispatch(createActions.updateWaveLayerCustomOptions(index, key, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(WaveLayerHollowCenterListItem);
